module.exports = __webpack_public_path__ + "img/dea-logo-blue.aa6d4147.svg";